import { render, staticRenderFns } from "./StudentManageModal.vue?vue&type=template&id=7b94390c&scoped=true&"
import script from "./StudentManageModal.vue?vue&type=script&lang=js&"
export * from "./StudentManageModal.vue?vue&type=script&lang=js&"
import style0 from "./StudentManageModal.vue?vue&type=style&index=0&id=7b94390c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b94390c",
  null
  
)

export default component.exports